export const GET_STAKE_OF_THE_DAY = 'GET_STAKE_OF_THE_DAY';
export const SUCCESS_GET_STAKE_OF_THE_DAY = 'SUCCESS_GET_STAKE_OF_THE_DAY';
export const FAILURE_GET_STAKE_OF_THE_DAY = 'FAILURE_GET_STAKE_OF_THE_DAY';



// WEBPACK FOOTER //
// ./js/actions/StakeOfTheDay.js